export const IOS_APP_URL = 'https://apps.apple.com/tr/app/bizbize/id1558150662?l=tr';
export const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.aselsan.bizbize';